import { SesionGuard } from './guards/sesion.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from 'src/app/error/error/error.component';
import { ViewPdfComponent } from './home/register/view-pdf/view-pdf.component';

const routes: Routes = [
  {
    path: '',

    redirectTo: 'home',

    pathMatch: 'full',
  },
  {
    path: 'home',
    canActivate: [SesionGuard],
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'login',
    canActivate: [SesionGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'caja',
    loadChildren: () => import('./caja/caja.module').then((m) => m.CajaModule),
  },

  {
    path: 'administracion',
    loadChildren: () =>
      import('./administracion/administracion.module').then(
        (m) => m.AdministracionModule
      ),
  },

  {
    path: 'error/:id',
    component: ErrorComponent,
  },
  {
    path: 'view-pdf/:doc',
    component: ViewPdfComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
